import { Type } from '@angular/core';

import { FilterTypesEnum } from '../enums/filters-types.enum';
import { FilterTypeModel } from '../../../Common/Filter/models/abstract-filter-type.model';
import { AbstractFilterTypeComponent } from './abstract-filter-type.component';

export abstract class CustomFilterTypeModel<T = any> extends FilterTypeModel<T> {
    readonly key: FilterTypesEnum = FilterTypesEnum.custom;

    customComponent: Type<AbstractFilterTypeComponent>;

    constructor(
        id: string,
        label: string,
        customComponent: Type<AbstractFilterTypeComponent>,
        section?: string,
        showIncludeExclude?: boolean
    ) {
        super(id, label, section, showIncludeExclude);

        this.customComponent = customComponent;
    }
}
